import React, { memo } from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useBaseIcon } from './BaseIcon.hooks'

const BaseIcon = props => {
	const [{ className, classes, component, viewBox }] = useBaseIcon(props)
	return (
		<SvgIcon
			component={component}
			className={clsx(className, classes.root)}
			viewBox={viewBox}
			style={{
				strokeWidth: 10,
			}}
		/>
	)
}

BaseIcon.propTypes = {
	className: PropTypes.string,
	viewBox: PropTypes.string.isRequired,
	component: PropTypes.elementType.isRequired,
}

export default memo(BaseIcon)
